const NON_ENTITY_KEYS = [ "time", "frame" ];

// TODO: hopefully in the future we get unique entity ids.
export default (skyviewBody) => {
    console.time("Process Skyview");

    const { skyview } = skyviewBody;

    const extents = [
        [180, 90],
        [-180, -90],
    ]
    const timeBetweenFrames = skyview[1].time - skyview[0].time;

    const framesProcessed = skyview.map((frame) => {
        const entities = [];
        const keys = Object.keys(frame).filter(d => !NON_ENTITY_KEYS.includes(d));
        keys.forEach(entityType => {
            frame[entityType].forEach(entity => {
                entities.push({
                    coords: [entity.lon, entity.lat],
                    type: entityType,
                });


                extents[0][0] = Math.min(extents[0][0], entity.lon);
                extents[0][1] = Math.min(extents[0][1], entity.lat);

                extents[1][0] = Math.max(extents[1][0], entity.lon);
                extents[1][1] = Math.max(extents[1][1], entity.lat);
                
            })
        })
        return {
            timeExtents: [frame.time, frame.time + timeBetweenFrames],
            entities,
        }
    })

    const center = [
        (extents[0][0] + extents[1][0]) / 2,
        (extents[0][1] + extents[1][1]) / 2,
    ]

    console.timeEnd("Process Skyview");
    return {
        frames: framesProcessed,
        extents,
        center,
    }
}


// WEBPACK FOOTER //
// ./src/modules/data/process-video-skyview.js